import { Topic } from './Dashboard';

enum VideoSource {
  ORA = 'ORA',
  OSMOSIS = 'OSMOSIS',
  CRASH_COURSE = 'CRASH_COURSE',
}

interface VideoVersion {
  id: string;
  mp4Url?: string;
  webmUrl?: string;
  youtubeURL?: string;
  withCam: boolean;
}

export enum WatchState {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export interface Video {
  id: string;
  title?: string;
  description?: string;
  caption: string;
  mp4Url: string;
  webmUrl: string;
  thumbnailUrl: string;
  topics: Topic[];
  citationUrl: string;
  citationAuthor: string;
  citationLicense: string;
  source: VideoSource;
  versions: VideoVersion[];
  createdAt: Date;
  updatedAt: Date;
  ord?: number;
  watchState?: WatchState;
}
